import { render, staticRenderFns } from "./TestResultDetail.vue?vue&type=template&id=18a476a1&"
import script from "./TestResultDetail.vue?vue&type=script&lang=js&"
export * from "./TestResultDetail.vue?vue&type=script&lang=js&"
import style0 from "./TestResultDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports